// extracted by mini-css-extract-plugin
export default {"form":"list-page_form__BlFdT","result":"list-page_result__pzKN+","row":"list-page_row__E1zJ2","item":"list-page_item__d7SGQ","input":"list-page_input__99ioy"};